import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  TextField,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  Modal,
  Grid,
  IconButton,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import React, { useEffect, useRef, useState } from "react";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import { convertDateToCustomFormat } from "../../utils/commonUtils";
import { ModalHeader } from "../../common/modalHeader";
export default function CandidateInformation({ open, setOpen, modalData }) {
  const onClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (open === true) {
    } else {
      console.log("close");
    }
  }, [open]);

  const formatDate = (date) =>
    new Date(date)
      .toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
      .replace(/ /g, "-");

  const labelStyle = {
    fontWeight: 500,
    color: "#01008B",
    fontSize: { xs: "12px", sm: "13px", md: "15px" },
    whiteSpace: "nowrap",
  };
  const labelStyle1 = {
    fontWeight: 600,
    color: "#000",
    fontSize: { xs: "12px", sm: "13px", md: "15px" },
    whiteSpace: "nowrap",
  };
  const valueStyle = {
    fontWeight: 500,
    color: "#000",
    fontSize: { xs: "12px", sm: "13px", md: "15px" },
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          background: "white",
          width: { xs: "95%", sm: "80%", md: "70%", lg: "50%" },
          overflowY: "auto",
          height: { xs: "80vh", sm: "70vh", md: "72vh", lg: "75vh" },
          position: "absolute",
          borderRadius: "10px",
          left: { xs: "2%", sm: "15%", md: "20%", lg: "25%" },
          top: "12%",
        }}
      >
        <ModalHeader title="Candidate Information" onClose={setOpen} />

        {/* <Divider sx={{ borderBottom: "1px solid #01008B" }} /> */}
        <DialogContent sx={{ p: 2, mt: 2 }}>
          <Grid container>
            {/* intro */}
            <Grid container spacing={2}>
              {/* LEFT SIDE */}
              <Grid item xs={12} md={7}>
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "160px 1fr",
                    rowGap: "8px",
                  }}
                >
                  <Typography sx={labelStyle}> Candidate Name :</Typography>
                  <Typography sx={valueStyle}>
                    {modalData?.name || "-"}
                  </Typography>

                  <Typography sx={labelStyle}>Mobile No. :</Typography>
                  <Typography sx={valueStyle}>
                    {modalData?.mobileNo || "-"}
                    {modalData?.mobileNo && (
                      <IconButton
                        size="small"
                        sx={{ p: 0 , ml: 1 }}
                        onClick={() =>
                          window.open(
                            `https://web.whatsapp.com/send?phone=${modalData?.mobileNo}`,
                            "_blank",
                          )
                        }
                      >
                        <WhatsAppIcon
                          sx={{
                            color: "white",
                            fontSize: 20,
                            borderRadius: "50%",
                            backgroundColor: "#25D366",
                            p: "3px",
                          }}
                        />
                      </IconButton>
                    )}
                  </Typography>

                  <Typography sx={labelStyle}>Date Of Birth :</Typography>
                  <Typography sx={valueStyle}>
                    {formatDate(modalData?.dateOfBirth) || "-"}
                  </Typography>

                  <Typography sx={labelStyle}>Address :</Typography>
                  <Typography sx={valueStyle}>
                    {modalData?.address || "-"}
                  </Typography>

                  <Typography sx={labelStyle}>Preferred Location :</Typography>
                  <Typography sx={valueStyle}>
                    {modalData?.preferredLocation || "-"}
                  </Typography>
                </Box>
              </Grid>

              {/* RIGHT SIDE */}
              <Grid item xs={12} md={5}>
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "120px 1fr",
                    rowGap: "8px",
                  }}
                >
                  <Typography sx={labelStyle}>Designation :</Typography>
                  <Typography sx={valueStyle}>
                    {modalData?.designation || "-"}
                  </Typography>

                  <Typography sx={labelStyle}>Email id :</Typography>
                  <Typography sx={valueStyle}>
                    {modalData?.emailId || "-"}
                  </Typography>

                  <Typography sx={labelStyle}>Gender :</Typography>
                  <Typography sx={valueStyle}>
                    {modalData?.gender || "-"}
                  </Typography>

                  <Typography sx={labelStyle}>City :</Typography>
                  <Typography sx={valueStyle}>
                    {modalData?.city || "-"}
                  </Typography>
                </Box>
              </Grid>
            </Grid>
            {/* ..Experience... */}
            <Grid item xs={12} sm={12} md={12}>
              <Box
                sx={{
                  border: "1.5px solid #01008B",
                  borderRadius: "8px",
                  p: 1,
                  mt: 2,
                  position: "relative",
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{
                    position: "absolute",
                    top: "-16px",
                    left: "12px",
                    backgroundColor: "#fff",
                    fontWeight: 500,
                    color: "#01008B",
                    px: 1,
                  }}
                >
                  Experience:
                </Typography>

                <Grid container spacing={1} sx={{ mt: 0 }}>
                  {/* box1 */}
                  {modalData?.experience.map((exp, index) => {
                    return (
                      <Grid item xs={12} md={6}>
                        <Box
                          sx={{
                            border: "1.5px solid #01008B",
                            borderRadius: "8px",
                            p: 1,
                          }}
                        >
                          <Box
                            sx={{
                              display: "grid",
                              gridTemplateColumns: "120px 1fr",
                              rowGap: "8px",
                            }}
                          >
                            <Typography sx={labelStyle1}>
                              Salon Name :
                            </Typography>
                            <Typography sx={valueStyle}>
                              {exp?.salonNamexp || "-"}
                            </Typography>

                            <Typography sx={labelStyle1}>From :</Typography>
                            <Typography sx={valueStyle}>
                              {" "}
                              {formatDate(exp?.fromDate) || "-"} To{" "}
                              {formatDate(exp?.toDate) || "-"}
                            </Typography>

                            <Typography sx={labelStyle1}>
                              Designation :
                            </Typography>
                            <Typography sx={valueStyle}>
                              {exp?.designation || "-"}
                            </Typography>

                            <Typography sx={labelStyle1}>City :</Typography>
                            <Typography sx={valueStyle}>
                              {exp?.city || "-"}
                            </Typography>
                          </Box>
                        </Box>
                      </Grid>
                    );
                  })}
                  {/* box2
                   */}
                  {/* <Grid item xs={12} md={6}>
                    <Box
                      sx={{
                        border: "1.5px solid #01008B",
                        borderRadius: "8px",
                        p: 1,
                      }}
                    >
                      <Box
                        sx={{
                          display: "grid",
                          gridTemplateColumns: "120px 1fr",
                          rowGap: "8px",
                        }}
                      >
                        <Typography sx={labelStyle1}>Salon Name :</Typography>
                        <Typography sx={valueStyle}>
                          The Palace Salon,Wakad
                        </Typography>

                        <Typography sx={labelStyle1}>From :</Typography>
                        <Typography sx={valueStyle}>
                          {" "}
                          Mar 2024 To Apr 2025
                        </Typography>

                        <Typography sx={labelStyle1}>Designation :</Typography>
                        <Typography sx={valueStyle}>Hair Dresser</Typography>

                        <Typography sx={labelStyle1}>City :</Typography>
                        <Typography sx={valueStyle}>Pune</Typography>
                      </Box>
                    </Box>
                  </Grid> */}
                </Grid>
              </Box>
            </Grid>

            {/* Skills Speciliation*/}
            <Grid item xs={12} md={10}>
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: "160px 1fr",
                  rowGap: "8px",
                  p: "10px",
                }}
              >
                <Typography sx={labelStyle}> Skills:</Typography>
                <Typography sx={valueStyle}>
                  {modalData?.skills || "-"}
                </Typography>

                <Typography sx={labelStyle}> Specializationls :</Typography>
                <Typography sx={valueStyle}>
                  {modalData?.specializations || "-"}
                </Typography>
              </Box>
            </Grid>

            {/* ..Education... */}
            <Grid item xs={12}>
              <Box
                sx={{
                  border: "1.5px solid #01008B",
                  borderRadius: "8px",
                  p: 1,
                  mt: 2,
                  position: "relative",
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{
                    position: "absolute",
                    top: "-16px",
                    left: "12px",
                    backgroundColor: "#fff",
                    fontWeight: 500,
                    color: "#01008B",
                    px: 1,
                  }}
                >
                  Education:
                </Typography>

                <Grid container spacing={1} sx={{ mt: 0 }}>
                  {/* BOX 1 */}
                  {modalData?.education?.map((edu, index) => {
                    return (
                      <Grid item xs={12} md={6}>
                        <Box
                          sx={{
                            border: "1.5px solid #01008B",
                            borderRadius: "8px",
                            p: 1,
                            // height: "100%",
                          }}
                        >
                          <Box
                            sx={{
                              display: "grid",
                              gridTemplateColumns: "140px 1fr",
                              rowGap: "8px",
                            }}
                          >
                            <Typography sx={labelStyle1}>
                              Course Name :
                            </Typography>
                            <Typography sx={valueStyle}>
                              {edu?.courseName || "-"}
                            </Typography>

                            <Typography sx={labelStyle1}>
                              Institute Name :
                            </Typography>
                            <Typography sx={valueStyle}>
                              {edu?.instituteName || "-"}
                            </Typography>

                            <Typography sx={labelStyle1}>
                              University Name :
                            </Typography>
                            <Typography sx={valueStyle}>
                              {edu?.universityName || "-"}
                            </Typography>

                            <Typography sx={labelStyle1}>
                              Date Of Passing :
                            </Typography>
                            <Typography sx={valueStyle}>
                              {formatDate(edu?.dateOfPassing) || "-"}
                            </Typography>

                            <Typography sx={labelStyle1}>
                              Percentage :
                            </Typography>
                            <Typography sx={valueStyle}>
                              {edu?.percentage || "-"}
                            </Typography>
                          </Box>
                        </Box>
                      </Grid>
                    );
                  })}

                  {/* BOX 2 */}
                  {/* <Grid item xs={12} md={6}>
                    <Box
                      sx={{
                        border: "1.5px solid #01008B",
                        borderRadius: "8px",
                        p: 1,
                        // height: "100%",
                      }}
                    >
                      <Box
                        sx={{
                          display: "grid",
                          gridTemplateColumns: "140px 1fr",
                          rowGap: "8px",
                        }}
                      >
                        <Typography sx={labelStyle1}>Course Name :</Typography>
                        <Typography sx={valueStyle}>12th</Typography>

                        <Typography sx={labelStyle1}>
                          Institute Name :
                        </Typography>
                        <Typography sx={valueStyle}>
                          Beauty Institute
                        </Typography>

                        <Typography sx={labelStyle1}>
                          University Name :
                        </Typography>
                        <Typography sx={valueStyle}>HSC </Typography>

                        <Typography sx={labelStyle1}>
                          Date Of Passing :
                        </Typography>
                        <Typography sx={valueStyle}>01 March 2012</Typography>

                        <Typography sx={labelStyle1}>Percentage :</Typography>
                        <Typography sx={valueStyle}>60</Typography>
                      </Box>
                    </Box>
                  </Grid> */}
                  {/* .box3 */}
                  {/* <Grid item xs={12} md={6}>
                    <Box
                      sx={{
                        border: "1.5px solid #01008B",
                        borderRadius: "8px",
                        p: 1,
                        // height: "100%",
                      }}
                    >
                      <Box
                        sx={{
                          display: "grid",
                          gridTemplateColumns: "140px 1fr",
                          rowGap: "8px",
                        }}
                      >
                        <Typography sx={labelStyle1}>Course Name :</Typography>
                        <Typography sx={valueStyle}>10th</Typography>

                        <Typography sx={labelStyle1}>
                          Institute Name :
                        </Typography>
                        <Typography sx={valueStyle}>
                          Beauty Institute
                        </Typography>

                        <Typography sx={labelStyle1}>
                          University Name :
                        </Typography>
                        <Typography sx={valueStyle}>SSC </Typography>

                        <Typography sx={labelStyle1}>
                          Date Of Passing :
                        </Typography>
                        <Typography sx={valueStyle}>01 March 2012</Typography>

                        <Typography sx={labelStyle1}>Percentage :</Typography>
                        <Typography sx={valueStyle}>87</Typography>
                      </Box>
                    </Box>
                  </Grid> */}
                </Grid>
              </Box>
            </Grid>

            {/* ....Imidiate avalable */}

            <Grid container spacing={2} p={2}>
              {/* LEFT SIDE */}
              <Grid item xs={12} md={6}>
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "minmax(100px, 180px) 1fr",
                    rowGap: "8px",
                  }}
                >
                  <Typography sx={labelStyle}> Immediate Available:</Typography>
                  <Typography sx={valueStyle}>
                    {modalData?.isImmediateAvailable === true ? "Yes" : "No"}
                  </Typography>

                  <Typography sx={labelStyle}>Current Salary :</Typography>
                  <Typography sx={valueStyle}>
                    {modalData?.currentSalary}/per month
                  </Typography>
                </Box>
              </Grid>

              {/* RIGHT SIDE */}
              <Grid item xs={12} md={6}>
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "minmax(100px, 180px) 1fr",
                    rowGap: "8px",
                  }}
                >
                  <Typography sx={labelStyle}>
                    Ready to join within :
                  </Typography>
                  <Typography sx={valueStyle}>
                    {modalData?.readyToJoinWithinDays}{" "}
                    {modalData?.readyToJoinWithinDays === "Immediate"
                      ? ""
                      : "Days"}
                  </Typography>

                  <Typography sx={labelStyle}>Expected Salary :</Typography>
                  <Typography sx={valueStyle}>
                    {modalData?.expectedSalary}/per Month
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
      </Box>
    </Modal>
  );
}
